module.exports = __webpack_public_path__ + "img/7.13d2c5e3.jpg";